import { createPortal } from "react-dom";
import { useLocation } from "wouter";
import { CompassLoader } from "@/components/compass-loader";
import { useAuth } from "@/hooks/use-auth";
import {
  usePortalTransition,
  useReleasePortalTransitionWhenReady,
} from "@/lib/portal-transition";

// Mounted beside AppContent so it stays up even when the shell early-returns
// the auth compass. Covers every intermediate screen until the destination
// portal is ready to paint.
export function PortalTransitionOverlay() {
  const [location] = useLocation();
  const { user, isLoading } = useAuth();
  const active = usePortalTransition();
  useReleasePortalTransitionWhenReady(location, user, active && !isLoading);

  if (!active || typeof document === "undefined") return null;
  return createPortal(
    <CompassLoader variant="fullscreen" cover />,
    document.body,
  );
}
